<template>
<div ref="settingsSideBar" id="settingsSideBar">
  <vs-sidebar parent="#settingsSideBar" class="settingsSidebar" position-left default-index="1" color="primary" spacer v-model="isActive" v-observe-visibility="{
    callback: visibilityChanged,
    once: true,
  }">
    <div class="purple-square-label">Name</div>
    <div class="border">
      <div id="clikName" v-html="clikNameFn" @focusout="updateName" class="settings-input" contenteditable="true" data-gramm_editor="false" spellcheck="false"></div>
    </div>
    <div class="purple-square-label description">Description</div>
    <div class="border">
      <div id="clikDescription" v-html="clikDescriptionFn" @focusout="updateDescription" class="settings-input" contenteditable="true" data-gramm_editor="false" spellcheck="false"></div>
    </div>
  </vs-sidebar>
</div>
</template>

<script>
import $ from 'jquery'
export default {
  props: {
    active: {
      type: Boolean
    },
    clikName: {
      type: String
    },
    clikDescription: {
      type: String
    }
  },
  data () {
    return {
      descriptionPlaceholder: 'Write a short description...',
      namePlaceholder: 'Clik Name'
    }
  },
  mounted () {

    $('#clikDescription').on('keyup keypress blur change', (event) => {
      if (event.key === 'Enter' || event.keyCode === 13) {
        event.preventDefault()
        return
      }
      while ($('#clikDescription').height() > 200) {
        $('#clikDescription').css('font-size', '-=1')
      }
      if (event.keyCode === 8 || event.keyCode === 46) {
        while ($('#clikDescription').height() <= 200 && $('#clikDescription').css('font-size') <= '30px') {
          $('#clikDescription').css('font-size', '+=1')
        }
        $('#clikDescription').css('font-size', '-=1')
      }
    })

    $('#clikName').on('keyup keypress blur change', (event) => {
      if (event.key === 'Enter' || event.keyCode === 13) {
        event.preventDefault()
        return
      }
      while ($('#clikName').height() > 200) {
        $('#clikName').css('font-size', '-=1')
      }
      if (event.keyCode === 8 || event.keyCode === 46) {
        while ($('#clikName').height() <= 200 && $('#clikName').css('font-size') <= '75px') {
          $('#clikName').css('font-size', '+=1')
        }
        $('#clikName').css('font-size', '-=1')
      }
    })

  },
  methods: {
    updateName (a) {
      this.$emit('updateClikName', a.target.textContent)
    },
    updateDescription (a) {
      this.$emit('updateClikDescription', a.target.textContent)
    },
    visibilityChanged () {
      $('#clikName').trigger('change')
      $('#clikDescription').trigger('change')
    }
  },
  computed: {
    isActive: {
      get () {
        return this.active
      },
      set (a) {
        this.$emit('updateSettingsSideBarState', a)
      }
    },
    clikNameFn: {
      get () {
        if (this.clikName === null) {
          return this.namePlaceholder
        }
        return this.clikName
      }
    },
    clikDescriptionFn: {
      get () {
        if (this.clikDescription === null) {
          return this.descriptionPlaceholder
        }
        return this.clikDescription
      }
    }
  }
}
</script>
<style lang="scss">
#settingsSideBar .vs-sidebar {
  max-width: 600px;
  background-color: #F8F8F8;
  padding: 3em;
}
.purple-square-label:first-of-type {
    margin-top: 80px;
}
.purple-square-label {
  font-size: 8px;
  font-weight: bold;
  letter-spacing: 0px;
  background: rgba(var(--vs-primary), 1) !important;
  color: white;
  width: 75px;
  font-size: 75%;
  letter-spacing: 2px;
  line-height: 25px;
  border-radius: 5px;
  text-align: center;
  text-transform: uppercase;
}
.description {
  margin-top: 40px;
  width: 120px;
}
.settings-input {
  margin-left: 20px;
  margin-top: 5px;
  border: none;
  border-color: transparent;
  background-color: transparent;
  font-size: 50px;
  text-transform: uppercase;
  font-weight: bold;
  color: #626262;
}
#clikName {
  width: 90%;
  font-size: 75px;
  padding: 15px;
  line-height: 90%;
}
#clikDescription {
  font-size: 30px;
  width: 90%;
  padding: 15px;
  line-height: 100%;
}
.border {
  width: 90%;
  height: 200px;
}
</style>
